(()=>{
 const labels=document.querySelector('[data-hm-cart-labels]')?.dataset||{};
 const root=()=>window.Shopify?.routes?.root||'/';
 const compact=document.querySelector('[data-hm-cart-compact="true"]')!==null;
 const cartFallback=()=>location.assign(root()+'cart');
 const kitVariant=58091281285502;
 const kitGiftVariants=[58363562197374,58363562230142,58363562262910];
 const giftProperties={_hm_kit_gift:String(kitVariant)};
 let giftSync=null;
 async function cartRequest(path,data){
  const response=await fetch(root()+path,{method:data?'POST':'GET',credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json',...(data?{'Content-Type':'application/json'}:{})},...(data?{body:JSON.stringify(data)}:{})});
  const result=await response.json();if(!response.ok)throw Error(result.description||result.message||labels.openError);return result;
 }
 function reconcileKitGifts(){
  if(!compact)return Promise.resolve(false);
  if(giftSync)return giftSync;
  giftSync=(async()=>{
   const cart=await cartRequest('cart.js');
   const quantity=cart.items.filter(x=>Number(x.variant_id)===kitVariant).reduce((n,x)=>n+x.quantity,0);
   const updates={},missing=[];
   for(const id of kitGiftVariants){
    const lines=cart.items.filter(x=>Number(x.variant_id)===id&&x.properties?._hm_kit_gift===String(kitVariant));
    if(lines.length){lines.forEach((line,index)=>{const wanted=index===0?quantity:0;if(line.quantity!==wanted)updates[line.key]=wanted;});}
    else if(quantity>0)missing.push({id,quantity,properties:giftProperties});
   }
   if(Object.keys(updates).length)await cartRequest('cart/update.js',{updates});
   if(missing.length)await cartRequest('cart/add.js',{items:missing});
   return Object.keys(updates).length>0||missing.length>0;
  })().finally(()=>{giftSync=null});
  return giftSync;
 }
 let opening = null;
 async function readyDrawer(){
  const drawer=document.querySelector('cart-drawer');
  if(!drawer)return null;
  if(typeof drawer.renderContents!=='function'){
   let timeout;
   await Promise.race([customElements.whenDefined('cart-drawer'),new Promise(resolve=>{timeout=setTimeout(resolve,4000)})]);
   clearTimeout(timeout);
  }
  return typeof drawer.open==='function'&&typeof drawer.renderContents==='function'?drawer:null;
 }
 window.HomyriaCart={compact,
  async afterAdd(fallback=cartFallback){
   if(!compact)return fallback();
   try{await this.open();return true}catch(error){cartFallback();return false}
  },
  returnUrl(){const url=new URL(location.href);url.searchParams.set('hm_open_cart','1');return url.pathname+url.search+url.hash},
  open(options={}){
  if(opening)return opening;
  opening=(async()=>{
  const drawer=await readyDrawer();
  if(!drawer){location.assign(root()+'cart');return}
  if(options.refresh===false){drawer.open();return}
  if(compact)await reconcileKitGifts();
  if(compact&&window.HomyriaNativeBundles?.reconcile)await window.HomyriaNativeBundles.reconcile();
  const ids=typeof drawer.getSectionsToRender==='function'?drawer.getSectionsToRender().map(x=>x.id):['cart-drawer','cart-icon-bubble'];
  const response=await fetch(root()+'?sections='+encodeURIComponent(ids.join(',')),{headers:{Accept:'application/json'},cache:'no-store'});
  if(!response.ok)throw Error(labels.openError);
  const sections=await response.json();if(!sections['cart-drawer'])throw Error(labels.openError);
  const freshDrawer=new DOMParser().parseFromString(sections['cart-drawer'],'text/html').querySelector('cart-drawer');
  if(!freshDrawer||compact&&!freshDrawer.querySelector('#CartDrawer .drawer__inner'))throw Error(labels.openError);
  drawer.classList.toggle('is-empty',freshDrawer.classList.contains('is-empty'));
  if(compact){drawer.renderContents({sections},true);if(!drawer.querySelector('#CartDrawer .drawer__inner'))throw Error(labels.openError);drawer.open()}else{drawer.renderContents({sections});drawer.open()}
  })().finally(()=>{opening=null});
  return opening;
 }};
 if(compact){const url=new URL(location.href);if(url.searchParams.get('hm_open_cart')==='1'){url.searchParams.delete('hm_open_cart');history.replaceState(null,'',url);const resume=()=>window.HomyriaCart.afterAdd();if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',resume,{once:true});else resume();}}
 document.addEventListener('submit',async e=>{
  const form=e.target;
  if(!form.matches('.hmm-product-form,.hm-related-form')&&!(compact&&form.matches('#homyria-kit-offer form[action*="/cart/add"]')))return;
  e.preventDefault();e.stopImmediatePropagation();
  const button=form.querySelector('[type="submit"]');if(!button||button.disabled)return;
  button.disabled=true;
  let message=form.querySelector('[data-hm-cart-message]');
  if(!message){message=document.createElement('p');message.dataset.hmCartMessage='';message.setAttribute('role','status');form.append(message)}
  message.textContent='';
  try{
   const data=new FormData(form);
   const deal=form.querySelector('.rapi-bundles__bar input[type=radio]:checked')?.closest('.rapi-bundles__bar');
   if(deal){const quantity=parseInt(deal.querySelector('.rapi-bundles__bar-title')?.textContent,10);if(quantity>0)data.set('quantity',String(quantity))}
   const giftConfig=compact&&form.querySelector('[data-hm-kit-gifts]');
   let response;
   if(giftConfig){
    const variants=JSON.parse(giftConfig.textContent).variants;
    if(variants.length!==3||!variants.every(v=>kitGiftVariants.includes(Number(v.id))&&Number(v.price)===0))throw Error('Les cadeaux gratuits ne sont pas disponibles. Veuillez réessayer.');
    const quantity=Number(data.get('quantity')||1),id=Number(data.get('id'));
    if(id!==kitVariant||!Number.isInteger(quantity)||quantity<1)throw Error(labels.addError);
    const items=variants.slice().reverse().map(v=>({id:Number(v.id),quantity,properties:giftProperties}));
    items.push({id,quantity});
    response=await fetch(root()+'cart/add.js',{method:'POST',headers:{Accept:'application/json','Content-Type':'application/json'},body:JSON.stringify({items})});
   }else response=await fetch(root()+'cart/add.js',{method:'POST',body:data,headers:{Accept:'application/json'}});
   const result=await response.json();if(!response.ok)throw Error(result.description||labels.addError);
   await (compact?window.HomyriaCart.afterAdd():window.HomyriaCart.open());
  }catch(error){message.textContent=error.message}finally{button.disabled=false}
 },true);
 document.addEventListener('click',e=>{const a=e.target.closest('a[href]');if(!a||e.defaultPrevented||e.ctrlKey||e.metaKey||e.shiftKey||e.altKey)return;const u=new URL(a.href,location.href);if(u.origin===location.origin&&u.pathname.replace(/\/$/,'')===root().replace(/\/$/,'')+'/cart'&&document.querySelector('cart-drawer')){e.preventDefault();e.stopImmediatePropagation();window.HomyriaCart.open({refresh:compact}).catch(()=>location.assign(root()+'cart'))}},true);
 if(compact){
  const watch=()=>{
   if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')subscribe(PUB_SUB_EVENTS.cartUpdate,async()=>{
    if(opening)return;
    try{
     const changed=await reconcileKitGifts();
     if(changed&&document.querySelector('cart-drawer.active'))await window.HomyriaCart.open();
     else if(changed&&/\/cart\/?$/.test(location.pathname))location.reload();
    }catch(error){const status=document.querySelector('#cart-errors');if(status)status.textContent=error.message;}
   });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',watch,{once:true});else watch();
 }
})();


